import { RefundModel } from 'api-hooks/refund/refund';
import { useFormState } from 'components/elements/form';
import TableInput from 'components/elements/table/table-input';
import { ColumnDataType, IColumn } from 'components/elements/table/type';
import { HeaderCheckbox } from 'legacy-modules/sales/reschedule/header-checkbox';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';

import { FormType } from '../../form-type';

interface Props {
  refund?: RefundModel;
}

function reducer(state, action, { replace, update, setValue, name }) {
  switch (action.type) {
    case 'update_cell':
      return {
        ...state,
        data: state.data.map((row, index) => {
          if (index === action.rowIndex) {
            const otherVal = () => {
              if (action.columnId === 'productVariantId') {
                return {
                  productName: action?.extra?.[0]?.label,
                  price: parseFloat(action?.extra?.[0]?.extra?.sellPrice) || 0,
                  stock: parseFloat(action?.extra?.[0]?.extra?.stock) || 0,
                };
              }
              return {};
            };
            const tempValue = {
              ...state.data[action.rowIndex],
              [action.columnId]: action.value,
              ...otherVal(),
            };

            // update(index, tempValue);
            setValue(`${name}.${index}`, tempValue, { shouldValidate: true });

            return tempValue;
          }
          return row;
        }),
      };
    case 'update_all':
      replace(action.newData);

      return {
        ...state,
        data: action.newData,
      };
    case 'isSelected':
      return {
        ...state,
        data: state.data.map((row, index) => {
          const tempValue = {
            ...state.data[index],
            isSelected: action.value,
          };
          // update(index, tempValue);
          setValue(`${name}.${index}`, tempValue, { shouldValidate: true });

          return tempValue;
        }),
      };
    default:
      return state;
  }
}

const _columns: (props: {
  t: any;
  editable?: boolean;
  name: string;
  dispatch;
}) => IColumn<any>[] = ({ t, editable, dispatch, name }) => [
  {
    header: () => <HeaderCheckbox name={name} dispatch={dispatch} />,
    accessorKey: 'isSelected',
    minSize: 50,
    size: 50,
    checkboxNoLabel: true,
    dataType: ColumnDataType.checkbox,
  },
  {
    header: t('product:product-variant'),
    accessorKey: 'productVariantName',
    minSize: 250,
    dataType: ColumnDataType.text,
    disabled: true,
  },
  {
    header: t('product:price_per_item'),
    accessorKey: 'price',
    minSize: 100,
    dataType: ColumnDataType.number,
    minNumber: 0,
    disabled: true,
  },
  {
    header: t('common:quantity'),
    accessorKey: 'qty',
    minSize: 100,
    dataType: ColumnDataType.number,
    minNumber: 0,
    disabled: true,
  },
  {
    header: t('common:description'),
    accessorKey: 'description',
    minSize: 300,
    dataType: ColumnDataType.text,
    maxNumberKey: 'stock',
    disabled: true,
  },
  {
    header: t('common:refund_price'),
    accessorKey: 'refundPrice',
    minSize: 100,
    dataType: ColumnDataType.number,
    minNumber: 0,
  },
];

export default function ProductVariantTable(props: Props) {
  const { t } = useTranslation();
  const { editable } = useFormState();

  const {
    formState: { isSubmitting },
    control,
    setValue,
  } = useFormContext<FormType>();

  const name: any = 'productSales';

  const { fields, replace, update } = useFieldArray({
    control,
    name,
    keyName: 'customId',
  });

  const [isInitiate, setIsInitiate] = React.useState<{
    value: boolean;
    data: any;
  }>({
    value: false,
    data: null,
  });

  const columns = (dispatch?: any) => _columns({ t, editable, dispatch, name });

  const [state, dispatch] = React.useReducer(
    (state, action) =>
      reducer(state, action, {
        replace,
        update,
        name,
        setValue,
      }),
    {
      columns: columns(),
      data: [],
    },
  );

  React.useEffect(() => {
    if (!isInitiate.value) {
      dispatch({
        type: 'update_all',
        newData: fields.length ? fields : [],
      });
      setIsInitiate({
        value: true,
        data: fields.length ? fields : [],
      });
    }
  }, [isInitiate, fields]);

  React.useEffect(() => {
    if (!editable && !isSubmitting && isInitiate.value) {
      dispatch({ type: 'update_all', newData: isInitiate.data });
    }
  }, [editable, isInitiate, isSubmitting]);

  return (
    <div style={{ width: '100%' }}>
      <TableInput
        columns={columns(dispatch)}
        data={state.data}
        dispatch={dispatch}
        disabled={!editable || !!props.refund}
        name={name}
        uniqueRowKey="customId"
        noAddRemoveRow
        onCustomDisabledCell={({ accessorKey, rowOriginal }) =>
          !!(accessorKey !== 'isSelected' && !rowOriginal.isSelected)
        }
      />
    </div>
  );
}
